import { PersistedClient, Persistor } from 'react-query/persistQueryClient-experimental';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { handlePersistStorage } from '../utils';

export const getPersistStorageInstance = (
    queryKeys: (QUERY_KEYS | string | string[])[],
    throttleTime?: number
) => {
    let persister: Persistor | undefined;

    const customSerializer = (client: PersistedClient): string => {
        return handlePersistStorage(client, queryKeys);
    };

    if (typeof window !== 'undefined') {
        persister = createWebStoragePersistor({
            storage: window.localStorage,
            serialize: customSerializer,
            throttleTime,
        });
    }
    return persister;
};
